import { BaseRequest } from './BaseRequest';

export class SearchOrganizationRequest extends BaseRequest {
    OrganizationId: string;
    Page: number;
}